const sectionType = Object.freeze({
    // SAT Reading and Writing Sections
    INFORMATION_AND_IDEAS: 'Information and Ideas',
    CRAFT_AND_STRUCTURE: 'Craft and Structure',
    EXPRESSION_OF_IDEAS: 'Expression of Ideas',
    STANDARD_ENGLISH_CONVENTIONS: 'Standard English Conventions',

    // SAT Math Sections
    ALGEBRA: 'Algebra',
    ADVANCED_MATH: 'Advanced Math',
    PROBLEM_SOLVING_AND_DATA_ANALYSIS: 'Problem-solving and Data Analysis',
    GEOMETRY_AND_TRIGONOMETRY: 'Geometry and Trigonometry',

    // Mixed Practice Sections
    PRACTICE_ALL_MATH: 'Practice All Math',
    PRACTICE_ALL_READING_WRITING: 'Practice All Reading & Writing',
});

export default sectionType;